import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    stores: null,
    partnerId: null,
    paypalEmail: null,
  },
  mutations: {
    ...mutations,
  },
  actions: {
    ...actions,
  },
  getters: {
    ...getters,
  },
}
